import React from 'react';
import Anime from 'react-anime';
import CustomScroll from 'react-custom-scroll';
import BackToHomeBtn from './BackToHomeBtn';
import { WritingsData, writingsData } from '../data/data';
import '../styles/WritingsPage.css';

const ArticleList = props => {
  return(
    <ul>
      {props.articleList.map(article => 
        <li>
          <a href={article.link} target="_blank">{article.title}</a>
          <br/>
          <span>{article.publishedOn}</span>
        </li>
      )}
    </ul>
  )
}

const WritingsPage = props => {
  return(
    <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
      <div className="writings-page">
          <BackToHomeBtn handleClick={props.returnBtn}/>
          <Anime easing="easeOutCubic" left={[-350, -120]} duration={500} delay={800}>
            <p className="page-tag">Writings</p>
          </Anime>
          <CustomScroll heightRelativeToParent="calc(100% - 20px)">
            <div className="page-content">
              <h1>I love to write about my learnings!</h1>
              <p className="page-intro">I love reading blogs and its safe to say that most of what I know comes from reading these blogs. I try my best to give back to community by writing blogs and tech snippets  about technology and experience I come across.
                <br/>
              Below are some of my posts that I have written recently.</p>
              <div className="article-list">
                <ArticleList articleList={writingsData}/>
              </div>
            </div>
          </CustomScroll>
      </div>
    </Anime>
  )
}

export default WritingsPage;


// WEBPACK FOOTER //
// ./src/components/WritingsPage.js